// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyASOCPRbKYy3oQBscJEYNCHp5jC0kSTV0Q",
  authDomain: "organic-store-5d667.firebaseapp.com",
  projectId: "organic-store-5d667",
  storageBucket: "organic-store-5d667.firebasestorage.app",
  messagingSenderId: "951551672704",
  appId: "1:951551672704:web:0fce549e67798afe26c165"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export default app;